const setUserInformation = (information) => {
  return { type: "SET_USER_INFORMATION", data: information };
};
const unsetUserInformation = () => {
  return { type: "SET_USER_INFORMATION", data: {} };
};

export { setUserInformation, unsetUserInformation };
